import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("neostore_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

export const formatUsdc = (n) =>
  `${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} USDC`;

export const formatMoney = (n) =>
  `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// Site-wide promotional discount display.
export const DISCOUNT_PERCENT = 40;
export const DISCOUNT_LABEL = `${DISCOUNT_PERCENT}% OFF`;
// The "was" price shown struck-through, derived so the current price reads as 40% off.
export const originalPrice = (n) =>
  Number((Number(n || 0) / (1 - DISCOUNT_PERCENT / 100)).toFixed(2));

// Buy X Get X Free tier for a PAID quantity — mirrors the backend rule.
// 1 -> 1 free / 0% off, 2-9 -> match free / 5% off, 10+ -> 10 free (cap) / 20% off.
export const BOGO_MAX_FREE = 10;
export function bogoTier(qty) {
  const q = Math.max(0, Math.floor(Number(qty) || 0));
  if (q <= 0) return { free: 0, pct: 0 };
  const free = Math.min(q, BOGO_MAX_FREE);
  const pct = q === 1 ? 0 : q >= 10 ? 0.2 : 0.05;
  return { free, pct };
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
